import React from 'react';
import styled from 'astroturf/react';

import routes from 'js/core_pre_webpack/routes';
import Timer from 'js/unibrows/seasonal_discount_unibrow/Timer';
import { currentUser } from 'js/utils/user';
import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';

type NewUserDiscountButtonProps = {
  feature: string;
  trigger: string;
  couponCode: string;
};

const Button = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 18px;
  cursor: pointer;
  flex-shrink: 0;
  margin-right: 12px;
`;

const ButtonText = styled.span<{ blue?: boolean }>`
  letter-spacing: 1.15px;
  font-size: 12px;
  text-transform: uppercase;
  color: #4b4b4b; /* Design system's grayDarkest */
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
  font-weight: normal;
  text-align: center;

  &.blue {
    color: #0954d3; /* Design system's blue */
  }
`;

const NewUserDiscountButton = ({
  feature,
  trigger,
  couponCode,
}: NewUserDiscountButtonProps) => {
  if (currentUser?.created_at === undefined) {
    return null;
  }

  const checkoutUrl = routes.checkout_url({
    feature,
    trigger,
    coupon_code: couponCode,
  });

  const promotionEnd = Date.parse(currentUser.created_at) + 24 * 60 * 60 * 1000;
  const startDuration = Math.floor((promotionEnd - Date.now()) / 1000);

  return (
    <ImpressionWatcher source={trigger}>
      <Button as={'a'} href={checkoutUrl}>
        <ButtonText blue>UPGRADE & GET 6 MONTHS FREE!</ButtonText>
        <Timer
          darkIndicator
          startDuration={startDuration}
          mini={true}
          style={{ paddingTop: 0 }}
        />
      </Button>
    </ImpressionWatcher>
  );
};

export default NewUserDiscountButton;
